// src/data/brands.ts

import type { Brand } from "@/types";

export const BRANDS: Brand[] = [
  {
    id:              "org-dewalt",
    name:            "DeWalt Tools",
    vertical:        "Home Improvement & Hardware",
    activeCampaigns: 3,
    totalSpend:      1_840_000,
  },
  {
    id:              "org-kraft",
    name:            "Kraft Heinz",
    vertical:        "Grocery & Mass Retail",
    activeCampaigns: 4,
    totalSpend:      3_120_000,
  },
  {
    id:              "org-nike",
    name:            "Nike",
    vertical:        "Fashion & Apparel",
    activeCampaigns: 2,
    totalSpend:      2_450_000,
  },
  {
    id:              "org-samsung",
    name:            "Samsung Electronics",
    vertical:        "Consumer Electronics",
    activeCampaigns: 3,
    totalSpend:      4_780_000,
  },
  {
    id:              "org-pgco",
    name:            "Procter & Gamble",
    vertical:        "Health & Wellness",
    activeCampaigns: 5,
    totalSpend:      5_640_000,
  },
];

// ── Brand performance snapshots ───────────────────────────────
export interface BrandPerformanceSnapshot {
  brandId:       string;
  brandName:     string;
  totalSpend:    number;
  totalImpressions: number;
  totalClicks:   number;
  totalConversions: number;
  avgRoas:       number;
  avgCtr:        number;
  avgCpc:        number;
  suppressionSavings: number;
  topChannel:    string;
  topAudience:   string;
  momSpendChange: number;  // % month-over-month
}

export const BRAND_SNAPSHOTS: BrandPerformanceSnapshot[] = [
  {
    brandId:          "org-dewalt",
    brandName:        "DeWalt Tools",
    totalSpend:       1_840_000,
    totalImpressions: 48_200_000,
    totalClicks:      824_000,
    totalConversions: 32_400,
    avgRoas:          4.8,
    avgCtr:           1.71,
    avgCpc:           2.23,
    suppressionSavings: 276_000,
    topChannel:       "Open Web Display",
    topAudience:      "Power Tool In-Market",
    momSpendChange:   12.4,
  },
  {
    brandId:          "org-kraft",
    brandName:        "Kraft Heinz",
    totalSpend:       3_120_000,
    totalImpressions: 124_800_000,
    totalClicks:      1_872_000,
    totalConversions: 148_000,
    avgRoas:          6.2,
    avgCtr:           1.50,
    avgCpc:           1.67,
    suppressionSavings: 468_000,
    topChannel:       "McClatchy O&O",
    topAudience:      "Grocery Loyalists — High Frequency",
    momSpendChange:   8.1,
  },
  {
    brandId:          "org-nike",
    brandName:        "Nike",
    totalSpend:       2_450_000,
    totalImpressions: 72_400_000,
    totalClicks:      1_086_000,
    totalConversions: 54_200,
    avgRoas:          5.4,
    avgCtr:           1.50,
    avgCpc:           2.26,
    suppressionSavings: 367_500,
    topChannel:       "CTV",
    topAudience:      "Athletic Wear Enthusiasts",
    momSpendChange:   -3.2,
  },
  {
    brandId:          "org-samsung",
    brandName:        "Samsung Electronics",
    totalSpend:       4_780_000,
    totalImpressions: 198_000_000,
    totalClicks:      2_574_000,
    totalConversions: 82_400,
    avgRoas:          7.1,
    avgCtr:           1.30,
    avgCpc:           1.86,
    suppressionSavings: 717_000,
    topChannel:       "CTV",
    topAudience:      "Consumer Electronics In-Market",
    momSpendChange:   22.7,
  },
  {
    brandId:          "org-pgco",
    brandName:        "Procter & Gamble",
    totalSpend:       5_640_000,
    totalImpressions: 248_000_000,
    totalClicks:      2_976_000,
    totalConversions: 312_000,
    avgRoas:          8.3,
    avgCtr:           1.20,
    avgCpc:           1.90,
    suppressionSavings: 846_000,
    topChannel:       "Open Web Display",
    topAudience:      "Health & Wellness Shoppers",
    momSpendChange:   5.6,
  },
];